export default __webpack_public_path__ + "static/media/mode-521.a03e24d1.svg";